import { render, staticRenderFns } from "./ProductividadComercial.vue?vue&type=template&id=5b8a96cf"
import script from "./ProductividadComercial.vue?vue&type=script&lang=js"
export * from "./ProductividadComercial.vue?vue&type=script&lang=js"
import style0 from "./ProductividadComercial.vue?vue&type=style&index=0&id=5b8a96cf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports